import React from 'react';
import { ISelectOption, ISpruceFieldProps, Select, SpruceField } from '../../../ui-toolkit/components';
import { eUSAState, StatesLabelValue } from '../../../ui-toolkit/enums/states';
import { ICountyData } from '../../../ui-toolkit/orders/searchOrder/types/ICounty';

export interface IStateCountySelectProps {
  stateName: string;
  countyName: string;
  onStateSelect: (state: eUSAState) => void;
  counties: ICountyData[] | null;
}

export const StateCountySelect: React.FC<IStateCountySelectProps> = ({
  stateName,
  countyName,
  onStateSelect,
  counties,
}) => {
  const stateFilterOptions = (option: ISelectOption<string>, value: string) =>
    option.value.toLowerCase().indexOf((value || '').toLowerCase()) >= 0;

  const countiesOptions: ISelectOption[] = counties
    ? counties.map((county) => ({
        label: county.name,
        value: county,
      }))
    : [];

  return (
    <>
      <SpruceField name={stateName} data-test-id={stateName} inputType={'select'}>
        {({ field, formik }: ISpruceFieldProps) => (
          <Select
            {...field}
            onChange={(value) => {
              field.onChange(value);
              formik.setFieldValue(countyName, null);
              onStateSelect(value ? value.value : undefined);
            }}
            isClearable={true}
            value={StatesLabelValue.find((state) => state.value === field.value) || null}
            options={StatesLabelValue}
            filterOption={stateFilterOptions}
            label={`State`}
            placeholder={`Select one...`}
          />
        )}
      </SpruceField>
      <SpruceField name={countyName} data-test-id={countyName} inputType={'select'}>
        {({ field, formik }: ISpruceFieldProps) => (
          <Select
            {...field}
            isDisabled={!formik.values[stateName]}
            hintText={formik.values[stateName] ? null : 'Select a State'}
            value={(field.value && countiesOptions.find((county) => county.value.name === field.value.name)) || null}
            options={countiesOptions}
            placeholder="Select a county"
            label="County"
          />
        )}
      </SpruceField>
    </>
  );
};
